import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowRightArrowLeft,
  faCircleInfo,
  faCircleQuestion,
  faCode,
  faGamepadModern,
  faInfoCircle,
  faLanguage,
  faLock,
  faTshirt,
  faUser,
  faUsers,
  faUserSecret,
  faUserTie,
  faVolume,
} from "@fortawesome/pro-solid-svg-icons";

interface ISettingsLink {
  title: string;
  icon: IconDefinition;
  path: string;
}

interface ISettingsSection {
  title: string;
  restricted?: boolean;
  links: ISettingsLink[];
}

export const vrSettingsSections: ISettingsSection[] = [
  {
    title: "settings.page.section.profile",
    links: [
      {
        title: "settings.page.link.my-profile",
        icon: faUser,
        path: "/settings/profile",
      },
      {
        title: "settings.page.link.my-kit",
        icon: faTshirt,
        path: "/settings/my-kit",
      },
      {
        title: "settings.page.link.switch-profile",
        icon: faArrowRightArrowLeft,
        path: "/select-profile",
      },
    ],
  },
  {
    title: "settings.page.section.account",
    links: [
      {
        title: "settings.page.link.default-kit",
        icon: faTshirt,
        path: "/settings/default-kit",
      },
      {
        title: "settings.page.link.members",
        icon: faUsers,
        path: "/settings/members",
      },
      {
        title: "settings.page.link.switch-account",
        icon: faArrowRightArrowLeft,
        path: "/select-account",
      },
      // {
      //   title: "settings.page.link.security",
      //   icon: faLock,
      //   path: "/settings/security",
      // },
    ],
  },
  {
    title: "settings.page.section.system",
    links: [
      {
        title: "settings.page.link.audio",
        icon: faVolume,
        path: "/settings/audio",
      },
      {
        title: "settings.page.link.in-game-feedback",
        icon: faInfoCircle,
        path: "/settings/feedback",
      },
      {
        title: "settings.page.link.controller",
        icon: faGamepadModern,
        path: "/settings/controller",
      },
      {
        title: "settings.page.link.language",
        path: "/settings/language",
        icon: faLanguage,
      },
    ],
  },
];

export const mobileSettingsSections: ISettingsSection[] = [
  {
    title: 'settings.page.section.profile',
    links: [
      {
        title: 'settings.page.link.my-profile',
        icon: faUser,
        path: '/settings/profile',
      },
      {
        title: 'settings.page.link.my-kit',
        icon: faTshirt,
        path: '/settings/my-kit',
      },
      {
        title: 'settings.page.link.switch-profile',
        icon: faArrowRightArrowLeft,
        path: '/settings/select-profile',
      },
    ],
  },
  {
    title: 'settings.page.section.account',
    links: [
      {
        title: 'settings.page.link.default-kit',
        icon: faTshirt,
        path: '/settings/default-kit',
      },
      {
        title: 'settings.page.link.members',
        icon: faUsers,
        path: '/settings/members',
      },
      {
        title: 'settings.page.link.switch-account',
        icon: faArrowRightArrowLeft,
        path: '/settings/select-account',
      },
    ],
  },
  {
    title: 'settings.page.section.general',
    links: [
      {
        title: 'settings.page.link.privacy',
        icon: faUserSecret,
        path: '/settings/privacy',
      },
      {
        title: 'settings.page.link.security',
        icon: faLock,
        path: '/settings/security',
      },
      {
        title: 'settings.page.link.help-and-support',
        icon: faCircleQuestion,
        path: '/settings/help',
      },
      {
        title: 'settings.page.link.about',
        icon: faCircleInfo,
        path: '/settings/about',
      },
      {
        title: 'settings.page.link.language',
        path: '/settings/language',
        icon: faLanguage,
      },
    ],
  },
  {
    title: 'settings.page.section.admin',
    restricted: true,
    links: [
      {
        title: 'settings.page.link.super-admin',
        icon: faUserTie,
        path: '/settings/admin',
      },
      {
        title: 'settings.page.link.dev-settings',
        icon: faCode,
        path: '/settings/dev-settings',
      },
    ],
  },
];
